import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { AuthService } from '@core/services';
import { PartnerPlan } from '@core/enum';

export const CrawlersGuard: CanActivateFn = () => {
  const auth = inject(AuthService);
  const router = inject(Router);

  const userRole = auth.userRole;
  const allowedRoles = ['support', 'manager', 'viewer'];

  if (!allowedRoles.includes(userRole)) {
    void router.navigate(['ssp-dsp-dashboard']);

    return false;
  }

  if (auth.partner.partner_plan !== PartnerPlan.Enterprise && !auth.partner.crawler) {
    void router.navigate(['ssp-dsp-dashboard']);

    return false;
  }

  return true;
};
